import React, { useState, useEffect } from "react";
import { IProps } from "../component";
import { Input, Form } from 'antd'
import { logger } from "../../../../../../../constant/winston";

const { Search } = Input

export const EmailVerifier = (props: IProps) => {
  const { properties } = props.json;
  const [buttonClick, setButtonClick] = useState<boolean>(false)
  const [seconds, setSeconds] = useState<number>(30)

  useEffect(() => {
    if (buttonClick && (seconds > 0)) {
      setTimeout(() => {
        setSeconds(seconds - 1)
      }, 1000)
    }
    if (buttonClick && seconds === 0) {
      setSeconds(30)
      setButtonClick(false)
    }
  }, [seconds, buttonClick])

  return (
    <>
      <Form.Item
        className={'a8-form-item override-common'}
        label={properties.label || 'Email Verifier'}
      >
        <Search data-test-id="email_address" placeholder='Enter Email Address' type="email" enterButton={buttonClick ? `RETRY IN ${seconds} SECONDS` : 'SEND VERIFICATION CODE'} onSearch={() => {
          setButtonClick(true)
        }} />
      </Form.Item>
      <Form.Item
        className={'a8-form-item override-common'}
        style={{ width: '50%', minWidth: '250px', marginTop: '14px' }}
      >
        <Search data-test-id="verification_code" placeholder='Enter Verification Code' enterButton='VERIFY CODE' onSearch={() => logger.debug('Call verify API')} />
      </Form.Item>
    </>
  );
};
